var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isShowTable
    ? _c(
        "MyModal",
        {
          style: { left: "25%", top: "25%", fontWeight: "500", zIndex: 2000 },
          attrs: { title: "风场方案对比", width: "670px", height: "auto" },
          on: {
            closeClick: function($event) {
              return _vm.handleCloseModalClick()
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "solid-table" },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.tableData,
                    "row-class-name": "table-row-class-name",
                    "header-row-style": {
                      background: "transparent"
                    },
                    "max-height": "500"
                  }
                },
                _vm._l(_vm.columns, function(col) {
                  return _c("el-table-column", {
                    key: col.prop,
                    attrs: {
                      prop: col.prop,
                      label: col.label,
                      type: col.type,
                      fixed: col.fixed,
                      "min-width": col.minWidth
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }